/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import Select from 'react-select'
import { Button, Form, Input } from 'semantic-ui-react'
import _ from 'lodash'

export default class ChoiceForm extends React.PureComponent {
  onChange = (field, value) => {
    const { choice, onChange } = this.props

    onChange({
      itemKey: choice.itemKey,
      discountRate: Number(choice.discountRate || 0),
      [field]: value,
    })
  }

  render() {
    const { choice, onRemove, items } = this.props

    return (
      <div style={{ display: 'flex' }}>
        <Form.Group widths="equal" style={{ display: 'flex', flex: 1 }}>
          <Form.Field required>
            <label>Item</label>
            <Select
              menuPlacement="top"
              isSearchable
              placeholder="Please choose item"
              onChange={e => this.onChange('itemKey', e.value)}
              options={items.existedValue}
              className="basic-single"
              classNamePrefix="select"
              defaultValue={_.find(items.existedValue, item => item.value === choice.itemKey)}
              required
            />
          </Form.Field>
          <Form.Field required>
            <label>Discount Rate</label>
            <Input
              label={{ content: '%' }}
              labelPosition="right"
              placeholder="e.g 10"
              type="number"
              onChange={e => this.onChange('discountRate', Number(e.target.value))}
              value={choice.discountRate}
              required
              min={1}
              max={100}
              step={0.1}
            />
          </Form.Field>
        </Form.Group>
        <div style={{ paddingTop: 25, marginLeft: 15 }}>
          <Button as="a" icon="trash" color="red" size="tiny" onClick={onRemove} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/promotions/forms/choiceForm.js